import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { getFontWeight } from '../../helpers/utils';

const variants = {
  size_44: {
    height: '44px',
    padding: '12px 16px',
  },
  size_32: {
    height: '32px',
    padding: '8px 12px',
  },
};

const ChooserElement = ({
  name,
  lexicon,
  font,
  is_required = false,
  value,
  onChange = () => { },
  placeholder,
  className = '',
  error,
  disabled = false,
  variant = 'size_44',
  list,
  attributes,
}) => {
  const [selected, setSelected] = useState(value || null);

  // Sync selected value when value prop changes (e.g., when navigating panels)
  useEffect(() => {
    if (value) {
      // Find the choice that matches the value (could be ID or name for backward compatibility)
      const choice = list?.choices?.find(c => c.id === value || c.name === value);
      setSelected(choice || null);
    } else {
      setSelected(null);
    }
  }, [value, list?.choices]);

  const handleChange = choice => {
    setSelected(choice);
    // Save the ID, not the name
    onChange(lexicon, choice?.id || '');
  };

  const choices = list?.choices || [];

  return (
    <ChooserElementWrapper className={className} variant={variants[variant]}>
      {name && (
        <label className="chooser-label mb-1" style={{ wordWrap: 'break-word', overflowWrap: 'break-word' }}>
          <span
            className="inter-500-text natural-900-text"
            style={{
              color: attributes?.font?.color,
              fontSize: attributes?.font?.size,
              fontWeight: getFontWeight(attributes?.font?.style),
              fontFamily: attributes?.font?.name,
              wordWrap: 'break-word',
              overflowWrap: 'break-word',
            }}>
            {name}
          </span>
          {is_required && <span className="required-star">!</span>}
        </label>
      )}
      <SelectWrapper>
        <select
          value={selected?.id || value || ''}
          onChange={e => {
            const choice = choices.find(c => c.id === e.target.value);
            handleChange(choice);
          }}
          disabled={disabled}
          className="chooser-select"
          style={{
            height: variants[variant].height,
            padding: variants[variant].padding,
            color: font?.color || attributes?.font?.color,
            fontSize: font?.size || attributes?.font?.size,
            fontWeight: getFontWeight(font?.style || attributes?.font?.style),
            fontFamily: font?.name || attributes?.font?.name,
          }}>
          <option value="">{placeholder || 'Select...'}</option>
          {choices.map(choice => (
            <option key={choice.id} value={choice.id}>
              {choice.name}
            </option>
          ))}
        </select>
      </SelectWrapper>
    </ChooserElementWrapper>
  );
};

const ChooserElementWrapper = styled('div')`
  width: 100%;
  max-width: 100%;
  min-width: 0;
  margin-bottom: 16px;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  overflow: hidden;
`;

const SelectWrapper = styled('div')`
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;

  .chooser-select {
    width: 100%;
    max-width: 100%;
    box-sizing: border-box;
    border: 1px solid #ddd;
    border-radius: 6px;
    background-color: #fff;
    cursor: pointer;
    appearance: none;
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 12 12'%3E%3Cpath fill='%23333' d='M6 9L1 4h10z'/%3E%3C/svg%3E");
    background-repeat: no-repeat;
    background-position: right 12px center;
    padding-right: 40px;

    &:disabled {
      opacity: 0.6;
      cursor: not-allowed;
    }

    &:focus {
      outline: none;
      border-color: #007bff;
    }
  }
`;

export default ChooserElement;
